import { FormHelperText } from "@material-ui/core";
import {
    AreaNotification,
    SelectInput,
    Text,
    TextArea,
    useNotifications,
} from "@relode/core";
import { TeamResponse } from "../../../../shared/backend/controllers/teams/teamResponse";
import * as React from "react";

import { useAddJobContext } from "../../_infra";
import { useClasses } from "./steps.styling";

interface Step1Props {
    handleFieldChange: (field: string) => (e: any) => void;
}
export const Step1 = (props: Step1Props) => {
    const classes = useClasses({});
    const { handleFieldChange } = props;

    const [uploadErrorMessage, setUploadErrorMessage] =
        React.useState<string>(undefined);

    const {
        state: {
            data: { teams },
            ui: { errors: uploadErrors, isLoading },
        },
        jobSteps,
        formikProps,
        setFieldValue,
    } = useAddJobContext();
    const { errors, setErrors } = formikProps;
    const { externalDescription, isIntegrated, hasActiveTeamPlan } =
        jobSteps.stepOne;

    const { actions: notifications } = useNotifications();

    React.useEffect(() => {
        const error = uploadErrors.find(e => e.type === "attachmentUpload");
        setUploadErrorMessage(error?.message);
    }, [uploadErrors]);

    React.useEffect(() => {
        if (hasActiveTeamPlan || isLoading)
            return notifications.closeAreaNotification(
                "addJobNoActiveTeamPlanWarning"
            );
        notifications.showArea(
            "warning",
            "Your plan has expired. Please contact your job manager to update your plan.",
            "addJobNoActiveTeamPlanWarning",
            { canClose: false }
        );
    }, [hasActiveTeamPlan, notifications, isLoading]);

    const handleTeamFieldChange = (e: never, newValue: TeamResponse) => {
        setFieldValue(newValue?.teamId ?? null, "stepTwo.teamId");
        if (!!newValue) {
            setFieldValue(parseInt(newValue.postalCode), "stepTwo.postalCode");
            setFieldValue(
                newValue.hasActiveTeamPlan,
                "stepTwo.hasActiveTeamPlan"
            );
        } else {
            setFieldValue(undefined, "stepTwo.postalCode");
        }
    };

    return (
        <div className={classes.form}>
            <AreaNotification areaName="addJobNoActiveTeamPlanWarning" />
            {!!teams ? (
                <div className={classes.section}>
                    <SelectInput
                        mode="suggest"
                        data-cy="team-select"
                        options={teams}
                        getOptionLabel={option => option.teamName}
                        label="organization"
                        onChange={handleTeamFieldChange}
                        disableTyping
                        defaultValue={teams?.[0]}
                    />
                </div>
            ) : null}
            <div className={classes.section}>
                {isIntegrated ? (
                    <>
                        <Text variant="subtitle2">
                            This job is integrated with your ATS and is updated
                            automatically.
                        </Text>
                        <br/>
                    </>
                ) : null}
                <TextArea
                    data-cy="externalDescription"
                    id="externalDescription"
                    className={classes.textAreaField}
                    label="type or paste job description"
                    name="stepOne.externalDescription"
                    value={externalDescription || ""}
                    disabled={isIntegrated}
                    autoFocus
                    multiline={true}
                    rows={10}
                    onChange={handleFieldChange("stepOne.externalDescription")}
                    error={!!errors.stepOne?.externalDescription}
                    helperText={
                        !!errors.stepOne
                            ? errors.stepOne.externalDescription
                            : null
                    }
                />
            </div>

            {!!uploadErrorMessage && (
                <div>
                    <FormHelperText error>{uploadErrorMessage}</FormHelperText>
                </div>
            )}
        </div>
    );
};
